﻿//import carData from './fetchCarsData.js';
import { Panel } from './panel.js';
import * as cacFilters from "./filters.js";


(function () {
    //function init() {
    ca_config.carSection = {
        el: document.querySelector('.car-section'),
        filtersHidden: document.querySelector('.car-section').dataset.hideFilters === "true",
        toggleFilters: function () {
            ca_config.carSection.el.dataset.hideFilters = ca_config.carSection.filtersHidden;
        }
    };
    const filterToggleBtn = document.querySelector('[data-toggle="filters"]');
    const filterToggleBtnText = filterToggleBtn.querySelector('.text');
    const filtersPanelContainer = document.querySelector('[data-panel-filters]');
    ca_config.filters = createFiltersPanel(filtersPanelContainer);
    const toggleFilterDisplay = function () {
        ca_config.carSection.filtersHidden = !ca_config.carSection.filtersHidden;
        ca_config.carSection.toggleFilters();
        filterToggleBtnText.textContent = ca_config.carSection.filtersHidden ? 'Show filters' : 'Hide filters';
    }
    function toggleFiltersPanel(e) {
        e.preventDefault();
        ca_config.filters.open();
    }

    filterToggleBtn.addEventListener('click', toggleFiltersPanel);
    //}

function createFiltersPanel(container) {
    const filtersPanel = new Panel('filters', container, {});
    //document.querySelectorAll('[data-panel="filters"]').forEach((item) => {
    //    item.addEventListener('click', function (e) {
    //        e.preventDefault();
    //        filtersPanel.open();
    //    });
    //});
    container.classList.remove('nojs');
    return filtersPanel;
    }

    const gotData = function (carData) {
        ca_config.selectListData = carData;
        cacFilters.init(ca_config);
    }

    fetch("/cars/data")
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            return response.json();
        })
        .then(gotData)
        .catch((error) => {
            console.error(`Could not get data: ${error}`);
        });

    //document.addEventListener("DOMContentLoaded", function (e) {
     // const fetch = fetch("/cars/data");
     // fetch
     //     .then((response) => {
     //         if (!response.ok) {
     //             throw new Error(`HTTP error: ${response.status}`);
     //         }
     //         return response.json();
     //     })
     //     .then((data) => {
     //         ca_config.selectListData = data;
     //         cacFilters.init(ca_config);
     //     })
     //     .catch((error) => {
     //         console.error(`Could not get data: ${error}`);
     //     });

    //  try {
    //      const response = await fetch("/cars/data");
    //      if (!response.ok) {
    //          throw new Error(`HTTP error: ${response.status}`);
    //      }
    //      const data = await response.json();
    //      ca_config.selectListData = data;
    //      cacFilters.init(ca_config);
    //  } catch (error) {
    //      console.error(`Could not get data: ${error}`);
    //      throw error;
    //  }

        
        //init();
    //});
})();


//